import React__default from 'react';
import { MoreButton } from '../../atoms/Button.js';
import { ActionMenuTrigger, ActionMenu, ActionMenuItem } from '../ActionMenu.js';
import { ToggleCard } from './ToggleCard.js';
import { ToggleCardHeader } from './ToggleCardHeader.js';
import './ToggleCardRadioContent.scss';

const ToggleCardRadioContent = (props) => {
    return (React__default.createElement(ToggleCard, { id: props.id },
        React__default.createElement(ToggleCardHeader, { accessory: React__default.createElement(ToggleCardRadioContentInternal, { ...props }) })));
};
const ToggleCardRadioContentInternal = ({ children, trailingAccessory, menuItems, className, }) => {
    return (React__default.createElement("div", { "data-rev-component": 'toggle-card-radio-content', className: className },
        children && React__default.createElement("div", { className: 'content-children--rev' }, children),
        (trailingAccessory || menuItems) && (React__default.createElement("div", { className: 'content-accessories--rev' },
            trailingAccessory && (React__default.createElement("div", { className: 'trailing-accessory--rev' }, trailingAccessory)),
            menuItems && menuItems.length > 0 && (React__default.createElement(ActionMenuTrigger, null,
                React__default.createElement(MoreButton, { "aria-label": 'More actions', variant: 'ghost' }),
                React__default.createElement(ActionMenu, null, menuItems.map((item, index) => (React__default.createElement(ActionMenuItem, { key: item.id || index, ...item }))))))))));
};

export { ToggleCardRadioContent };
//# sourceMappingURL=ToggleCardRadioContent.js.map
